// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icons_icon__3cTXQ"};